<template>
    <div class="enterprise-resource-librarie-upload-task">
        <div style="display: flex;">
            <div style="margin-left: auto;"><i class="el-icon-refresh" style="cursor: pointer;color: #409EFF;"
                    @click="loadTable"></i></div>
        </div>
        <el-table :data="tableData" style="width: 100%;margin-top: 0.2rem" border size="mini" :header-cell-style="{
            background: '#ecf4ff',
            color: '#333',
            fontWeight: '900',
            fontSize: '0.28rem'
        }" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.4)">
            <el-table-column prop="" label="序号" width="50" align="center">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="file_name" label="文件名" width="" align="center">
                <template slot-scope="scope">
                    {{ scope.row.file_name }}
                    <!-- <el-progress :percentage="percentage" status="success"></el-progress> -->
                </template>
            </el-table-column>
            <el-table-column prop="" label="创建人" width="" align="center">
                <template slot-scope="scope">
                    <div>
                        <div>{{ scope.row.admin_user_name }}</div>
                        <div>{{ scope.row.created_at }}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="任务状态" width="" align="center">
            </el-table-column>
            <el-table-column prop="total_num" label="文件内总数" width="" align="center">
            </el-table-column>
            <el-table-column prop="success_num" label="进入资源库数量" width="" align="center">
            </el-table-column>
            <el-table-column prop="exists_num" label="重复数量" width="" align="center">
            </el-table-column>
            <el-table-column prop="invalid_num" label="无效条目数" width="" align="center">
            </el-table-column>
        </el-table>
        <div style="text-align: right;">
            <pagination-com :total="total" :perPage="pageSize" :npage="npage" @handleSizeChange="handleSizeChange"
                @handleCurrentChange="handleCurrentChange" />
        </div>
    </div>
</template>


<script>
import PaginationCom from '../../../commonReform/PaginationCom';
import { AutoHyperfHost } from '@/config'
import { AutoHyperfHost_SocketIO } from '@/config/socketIOService'
import { socketIOAddress } from '@/config/socketIOAddress'
import io from 'socket.io-client';
export default {
    name: 'EnterpriseResourceLibrarieUploadTask',
    components: { PaginationCom },
    data() {
        return {
            tableData: [],
            loading: false,
            pageSize: 30,
            total: 0,
            npage: 1,
            hyperfHost:
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:9501/v1/"
                    : "https://qyh-next-server.zhang66.cn/v1/",
            hyperfHostWithOutV1:
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:9501/"
                    : "https://qyh-next-server.zhang66.cn/",
            socket: null,
            percentage: 0,
        }
    },
    methods: {
        loadTable() {
            this.loading = true
            this.$axios.get(`${this.hyperfHost}api/qyh/crue/index?page=${this.npage}`, {
                loadingClose: true,
                params: {
                    perPage: this.pageSize,
                    // searchArr: this.searchArr,
                },
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.loading = false
                    this.tableData = data.data.data
                    this.total = data.data.total
                }
            }).catch()
        },
        handleSizeChange(val) {
            this.npage = 1;
            this.pageSize = val;
            this.loadTable();
        },
        handleCurrentChange(val) {
            this.npage = val;
            this.loadTable();
        },
        sendMessage(msg) {
            if (this.socket.readyState === WebSocket.OPEN) this.socket.send(msg ? msg : 'Hello Hyperf!I\'m Home')
        },
        getProcessData() {
            this.socket.send(JSON.stringify(['App\\Controller\\TestController', 'websocketSendMessage']));
        },
        receiveProcessData($data) {
            console.log($data, 'data')
            console.log(($data[0] - $data[1]) / $data[0], '进度')
            this.percentage = Math.floor((($data[0] - $data[1]) / $data[0]) * 100)
        }
    },
    mounted() {
        // this.loadTable()
        //     const script = document.createElement('script');
        // script.src = 'https://cdn.bootcdn.net/ajax/libs/socket.io/2.3.0/socket.io.js';
        // script.async = true;
        // script.onload = () => {
        //     var socket = io(`ws://{${AutoHyperfHost_SocketIO}}`, { transports: ["websocket"] });
        // socket.on('connect', data => {
        //     socket.emit('event', 'hello, hyperf', console.log);
        //     socket.emit('join-room', 'room1', console.log);
        //     setInterval(function () {
        //         socket.emit('say', '{"room":"room1", "message":"Hello Hyperf."}');
        //     }, 1000);
        // });
        // socket.on('event', console.log);
        // };
        // document.body.appendChild(script); 
    },
    // created() {
    //     this.socket = new WebSocket(`${AutoHyperfHost}`);

    //     this.socket.onopen = (event) => {
    //         console.log('WebSocket is open now.')
    //         // this.sendMessage()
    //         this.getProcessData()
    //     }

    //     this.socket.onclose = (event) => {
    //         console.log('WebSocket is closed now.')
    //     }

    //     this.socket.onerror = (event) => {
    //         console.log('WebSocket error observed', event)
    //     }

    //     this.socket.onmessage = (event) => {
    //         // this.sendMessage(event.data)

    //         try {
    //             let data = JSON.parse(event.data)
    //             console.log(data, 'not send')
    //             this[data[0]](data[1])
    //         } catch (e) {

    //         }

    //     }
    // },
    created() {
        this.loadTable()

        // 创建一个新的Socket.IO连接
        // 你需要将'http://localhost:9502'替换为你的实际服务器地址和端口
        this.socket = io(`${socketIOAddress}`, { transports: ['websocket'] });

        // 监听'connect'事件，当客户端成功连接到服务器时，这个事件会被触发
        this.socket.on('connect', () => {
            console.log('connected to server');
            this.socket.emit('join-room', 'enterpriseResourceLibrarieUploadTask');
        });

        // 你也可以监听其他事件，例如'message'事件
        // this.socket.on('message', (data) => {
        //     console.log('received message:', data);
        // });
        this.socket.on('join-room', (data) => {
            console.log('received message:', data);
        });

        this.socket.on('event', (data) => {
            console.log('join_room', data);
        })


        this.socket.on('update_total', (data) => {
            console.log('update_total', data);
            this.tableData.forEach((item, index) => {
                if (item.id === data[0]) {
                    // 使用 Vue.set 方法
                    // this.$set(this.tableData, index, data[1]);

                    // 或者使用索引赋值的方式
                    this.tableData[index] = data[1];
                }
            })
        })

        // 如果你想发送一个消息到服务器，你可以使用emit方法
        // 这将发送一个名为'my event'的事件，带有一个对象作为数据
        // this.socket.emit('event', { data: 'Hello, server!' });
        this.socket.emit('event', 'Hello, server!', (data) => {
            console.log(data)
        });
    },
    beforeDestroy() {
        // if (this.socket) this.socket.close()
        if (this.socket) this.socket.disconnect()
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/cloudClue/Components/EnterpriseResourceLibrarieUploadTask.vue